﻿module.exports = {
    bindings: {
        group: '<',
        measuretitle: '<'
    },
    templateUrl: 'good/components/grouped-vat-measures.html'
};